import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
import AdminTable from '../../../components/admin/AdminTable';
import React, { useEffect, useState } from 'react';
import Loading from '../../../components/Loading';
import { Edit, Trash2, Plus, History, ShieldCheck } from 'lucide-react';
import { fetchRoutePermissions, RoutePerm } from '../../../services/permissionService';
import AddPermissionModal from '../../../components/Permission/AddPermissionModal';
import EditPermissionModal from '../../../components/Permission/EditPermissionModal';
import DeletePermissionModal from '../../../components/Permission/DeletePermissionModal';
import Pagination from '../../../components/Pagination/Pagination';
import ExpiredSessionModal from '../../../components/Expired/ExpiredSessionModal';
import { useSessionExpiration } from '../../../hooks/useSessionExpiration';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useModelPermission } from '../../../hooks/useModelPermission';

const PermissionPage: React.FC = () => {
    const [permissions, setPermissions] = useState<RoutePerm[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedPermission, setSelectedPermission] = useState<RoutePerm | null>(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedPermissionToDelete, setSelectedPermissionToDelete] = useState<RoutePerm | null>(null);
    const navigate = useNavigate();

    // Manejo de expiración de sesión
    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();
    const { logout, user } = useAuth();
    const userLevelId = user?.user_level_id ?? 0;
    const perm = useModelPermission('routepermission', userLevelId);

    const fetchPermissions = async () => {
        try {
            const data = await fetchRoutePermissions();
            const sortedData = data.sort((a, b) => a.id - b.id);
            setPermissions(sortedData);
        } catch (error) {
            /* Browser diagnostics omitted. */
        }
    };

    useEffect(() => {
        const load = async () => {
            try {
                if (perm?.can_read) {
                    const data = await fetchRoutePermissions();
                    setPermissions(data.sort((a, b) => a.id - b.id));
                } else {
                    setPermissions([]);
                }
            } catch {
                setPermissions([]);
            }
        };
        load();
    }, [perm]);

    const handleDeletePermission = (perm: RoutePerm) => {
        setSelectedPermissionToDelete(perm);
        setIsDeleteModalOpen(true);
    };

    // Lógica de paginación
    const totalPages = Math.ceil(permissions.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const displayedPermissions = permissions.slice(startIndex, startIndex + itemsPerPage);

    if (perm === null) return <Loading text="Cargando permisos..." />;

    return <><LumaResourceWorkspace title="Permisos de rutas" description="Consulta y gestiona la información de tu coworking." group="Configuraciones" rows={permissions} columns={[{key:'path',label:'Ruta'},{key:'allowed_roles',label:'Roles permitidos'},{key:'activo',label:'Estado'}]} idKey="id" nameKey="path" statusKey="activo" canRead={perm?.can_read} onCreate={perm?.can_create?()=>{setIsModalOpen(true)}:undefined} onEdit={perm?.can_update?r=>{setSelectedPermission(r);setIsEditModalOpen(true);}:undefined} onDelete={perm?.can_delete?handleDeletePermission:undefined}/><AddPermissionModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    onPermissionAdded={fetchPermissions}
                /><EditPermissionModal
                    isOpen={isEditModalOpen}
                    onClose={() => {
                        setIsEditModalOpen(false);
                        setSelectedPermission(null);
                    }}
                    onPermissionUpdated={fetchPermissions}
                    permission={selectedPermission}
                /><DeletePermissionModal
                    isOpen={isDeleteModalOpen}
                    onClose={() => setIsDeleteModalOpen(false)}
                    onPermissionDeleted={fetchPermissions}
                    permission={selectedPermissionToDelete}
                /><ExpiredSessionModal
                    isOpen={isSessionExpired}
                    onClose={async () => {
                        setIsSessionExpired(false);
                        await logout();
                    }}
                /></>;
};

export default PermissionPage;

